import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

const viewMoreButton = document.querySelector(".view-more");

if (window.location.hash) {
  // Fragment exists
  const hash = window.location.hash.replace(/#/, '');
  // const hash = window.location.hash;
  const tableRow = document.getElementById(hash);
  if (tableRow) {
    const moreInfoButton = tableRow.querySelector(".floor-plan-button")
    if (!moreInfoButton.classList.contains("hidden")) {
      moreInfoButton.click();
    }
    viewMoreButton.click();
    tableRow.scrollIntoView();
  }
}

const moreInfoButtons = document.querySelectorAll((".floor-plan-button"));
const refreshScrollTriggers = () => {
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 500)
  console.log("refreshed");
}

moreInfoButtons.forEach(button => {
  button.addEventListener("click", refreshScrollTriggers)
})

if (viewMoreButton) {
  viewMoreButton.addEventListener("click", refreshScrollTriggers);
}
